// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EntitlementType } from './EntitlementType';
import {
  EntitlementTypeFromJSON,
  EntitlementTypeFromJSONTyped,
  EntitlementTypeToJSON,
  EntitlementTypeToJSONTyped,
} from './EntitlementType';

/**
 *
 * @export
 * @interface CreateEntitlementRequest
 */
export interface CreateEntitlementRequest {
  /**
   * start timestamp, RFC3339
   * @type {Date}
   * @memberof CreateEntitlementRequest
   */
  start: Date;
  /**
   * end timestamp, RFC3339
   * @type {Date}
   * @memberof CreateEntitlementRequest
   */
  end: Date;
  /**
   * cost basis
   * @type {string}
   * @memberof CreateEntitlementRequest
   */
  costBasis: string;
  /**
   * amount of ACUs
   * @type {number}
   * @memberof CreateEntitlementRequest
   */
  amount: number;
  /**
   * percentage of unused ACUs that roll over to the next period (optional)
   * @type {number}
   * @memberof CreateEntitlementRequest
   */
  rolloverPercentage?: number;
  /**
   *
   * @type {EntitlementType}
   * @memberof CreateEntitlementRequest
   */
  type: EntitlementType;
  /**
   * Salesforce subscription ID (optional)
   * @type {string}
   * @memberof CreateEntitlementRequest
   */
  salesforceSubID?: string;
  /**
   * provisioning ID (optional)
   * @type {string}
   * @memberof CreateEntitlementRequest
   */
  provisioningID?: string;
}

/**
 * Check if a given object implements the CreateEntitlementRequest interface.
 */
export function instanceOfCreateEntitlementRequest(
  value: object,
): value is CreateEntitlementRequest {
  if (!('start' in value) || value['start'] === undefined) return false;
  if (!('end' in value) || value['end'] === undefined) return false;
  if (!('costBasis' in value) || value['costBasis'] === undefined) return false;
  if (!('amount' in value) || value['amount'] === undefined) return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  return true;
}

export function CreateEntitlementRequestFromJSON(
  json: any,
): CreateEntitlementRequest {
  return CreateEntitlementRequestFromJSONTyped(json, false);
}

export function CreateEntitlementRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateEntitlementRequest {
  if (json == null) {
    return json;
  }
  return {
    start: new Date(json['start']),
    end: new Date(json['end']),
    costBasis: json['costBasis'],
    amount: json['amount'],
    rolloverPercentage:
      json['rolloverPercentage'] == null
        ? undefined
        : json['rolloverPercentage'],
    type: EntitlementTypeFromJSON(json['type']),
    salesforceSubID:
      json['salesforceSubID'] == null ? undefined : json['salesforceSubID'],
    provisioningID:
      json['provisioningID'] == null ? undefined : json['provisioningID'],
  };
}

export function CreateEntitlementRequestToJSON(
  json: any,
): CreateEntitlementRequest {
  return CreateEntitlementRequestToJSONTyped(json, false);
}

export function CreateEntitlementRequestToJSONTyped(
  value?: CreateEntitlementRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    start: value['start'].toISOString(),
    end: value['end'].toISOString(),
    costBasis: value['costBasis'],
    amount: value['amount'],
    rolloverPercentage: value['rolloverPercentage'],
    type: EntitlementTypeToJSON(value['type']),
    salesforceSubID: value['salesforceSubID'],
    provisioningID: value['provisioningID'],
  };
}
